import i18next from "../../services/language/i18next";
import {ACTIONS, hasGlobalPermission} from "../../utils/user-access";

const getTableColumnHeaders = () => (
  [
    {
      key: "first_name",
      label: i18next.t("table:header.firstName", "First Name"),
      _style: {width: "20%"},
      isShown: hasGlobalPermission(ACTIONS.VIEW_MEMBERS_LIST)
    },
    {
      key: "last_name",
      label: i18next.t("table:header.lastName", "Last Name"),
      _style: {width: "20%"},
      isShown: hasGlobalPermission(ACTIONS.VIEW_MEMBERS_LIST)
    },
    {
      key: "phone",
      label: i18next.t("table:header.phone", "Phone"),
      _style: {width: "20%"},
      sorter: false,
      isShown: hasGlobalPermission(ACTIONS.VIEW_MEMBERS_LIST)
    },
    {
      key: "email",
      label: i18next.t("table:header.email", "Email"),
      _style: {width: "20%"},
      sorter: false,
      isShown: hasGlobalPermission(ACTIONS.VIEW_MEMBERS_LIST)
    },
    {
      key: "member_directory_name",
      label: i18next.t("table:header.directory", "Directory"),
      _style: {width: "20%"},
      isShown: hasGlobalPermission(ACTIONS.VIEW_MEMBERS_LIST)
    }
  ].filter((item) => item.isShown)
);

const getTableFilterText = () => ({
  label: i18next.t("table:filter.label", "Search:"),
  placeholder: i18next.t("table:filter.placeholder.members", "Search for members"),
  external: true
});

export {
  getTableColumnHeaders,
  getTableFilterText
};